export default {
  en: {
    MaterialCreateScene: {
      title: 'Create material',
    },
  },
};
